import React from "react";
import ErrorIcon from "@material-ui/icons/Error";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { notification_color_keys } from "utils/hooks/useNotifications";

export const EINVOICE_FIELD_KEYS = {
  CUSTOMER_NAME: "customer_name",
  CUSTOMER_EMAIL: "customer_email",
  CUSTOMER_PHONE: "customer_phone",
  INVOICE_NUMBER: "invoice_number",
  IRN_NUMBER: "irn_number",
  TRANSACTION_UUID: "uuid",
  STATUS: "status",
  EINVOICE_STATUS: "einvoice_status",
  FAILURE_REASON: "failure_reason",
  INVOICE_VALUE: "invoice_value",
  CURRENCY: "currency",
  OFFERING_NAME: "offering_name",
  OFFERING_TYPE: "offering_type",
  INVOICE_DATE: "invoice_date",
  KYC_DETAILS: "kyc_details",
  GST_INFO: "gst_info",
  INVOICE_DATE_START_RANGE: "created_at__start_range",
  INVOICE_DATE_END_RANGE: "created_at__end_range",
};

export const EINVOICE_CONTACT_COLUMN_WIDTH = "140px";
export const EINVOICE_EMAIL_COLUMN_WIDTH = "200px";

export const EINVOICE_TRANSACTION_UUID_FILTER_KEY = `${EINVOICE_FIELD_KEYS.TRANSACTION_UUID}__icontains`;

export const EINVOICE_FILTERS = {
  TOTAL: "total",
  ALL: "all",
  SUCCESSFUL: "successful",
  FAILED: "failed",
};

export const EINVOICE_MESSAGES = {
  RETRY_SUCCESS: "Retry successful",
  RETRY_FAILED: "Retry e-invoice API failed",
};

export const E_INVOICE_STATUS_ENUM = {
  NOT_ELIGIBLE: 1,
  GENERATED: 2,
  FAILED: 3,
  PENDING: 4,
};

export const E_INVOICE_STATUS_LABELS = {
  2: "Generated",
  3: "Failed",
  4: "Pending",
};

export const E_INVOICE_FILTER_KEYS = {
  STATUS: "einvoice_status",
};

export const E_INVOICE_STATUS = {
  [E_INVOICE_STATUS_ENUM.FAILED]: {
    id: E_INVOICE_STATUS_ENUM.FAILED,
    title: "FAILED",
    variant: notification_color_keys.error,
    backgroundColor: "#FDEDED",
    color: "#EB5757",
    icon: <ErrorIcon fontSize="small" className="tw-mr-1 tw-text-red-500" />,
  },
  [E_INVOICE_STATUS_ENUM.GENERATED]: {
    id: E_INVOICE_STATUS_ENUM.GENERATED,
    title: "GENERATED",
    variant: notification_color_keys.success,
    backgroundColor: "#E9F7EF",
    color: "#27AE60",
    icon: (
      <CheckCircleIcon fontSize="small" className="tw-mr-1 tw-text-green-500" />
    ),
  },
  [E_INVOICE_STATUS_ENUM.PENDING]: {
    id: E_INVOICE_STATUS_ENUM.PENDING,
    title: "PENDING",
    variant: notification_color_keys.warning,
    backgroundColor: "#FFF7DA",
    color: "#B7791F",
    icon: <ErrorIcon fontSize="small" className="tw-mr-1 tw-text-yellow-500" />,
  },
};

export const MANAGE_E_INVOICE = "manage-e-invoice";

export const HEADER_NOTE = {
  title: "Manage E-Invoice",
  sub_heading: "View and manage all your e-invoices here.",
};

export const SUMMARY_BOXES = [
  {
    id: "total",
    title: "Total E-invoices",
    icon: "total_icon",
    color: "#635BFF",
    backgroundColor: "#F4F3FF",
  },
  {
    id: "successful",
    title: "Successful",
    icon: "successful_icon",
    color: "#27AE60",
    backgroundColor: "#E9F7EF",
  },
  {
    id: "failed",
    title: "Failed",
    icon: "failed_icon",
    color: "#EB5757",
    backgroundColor: "#FDEDED",
  },
];

export const EINVOICE_FORM_FIELDS = {
  COMPANY_NAME: "company_name",
  GST_NUMBER: "gst_number",
  COMPANY_ADDRESS: "company_address",
  STATE: "state",
  COMPANY_PINCODE: "company_pincode",
  TRANSACTION_UUID: "transaction_uuid",
};

export const SUMMARY_BOX_DESCRIPTIONS = {
  total: "Total E-Invoices Processed",
  successful: "Successfully Generated E-Invoices",
  failed: "Failed E-Invoice Generations",
};

export const EINVOICE_STATUS_OPTIONS = [
  {
    id: "successful",
    title: "Successful",
  },
  {
    id: "failed",
    title: "Failed",
  },
];

export const EINVOICE_STATUS_VALUES = {
  GENERATED: "Generated",
  FAILED: "Failed",
  PENDING: "Pending",
};

export const normalizeEInvoiceStatus = (status) => {
  if (status === null || status === undefined || status === "") return status;

  const stringStatusMap = {
    [EINVOICE_STATUS_VALUES.GENERATED]: E_INVOICE_STATUS_ENUM.GENERATED,
    [EINVOICE_STATUS_VALUES.FAILED]: E_INVOICE_STATUS_ENUM.FAILED,
    [EINVOICE_STATUS_VALUES.PENDING]: E_INVOICE_STATUS_ENUM.PENDING,
    GENERATED: E_INVOICE_STATUS_ENUM.GENERATED,
    FAILED: E_INVOICE_STATUS_ENUM.FAILED,
    PENDING: E_INVOICE_STATUS_ENUM.PENDING,
    generated: E_INVOICE_STATUS_ENUM.GENERATED,
    failed: E_INVOICE_STATUS_ENUM.FAILED,
    pending: E_INVOICE_STATUS_ENUM.PENDING,
  };

  if (stringStatusMap[status] !== undefined) {
    return stringStatusMap[status];
  }

  const numericStatus = Number(status);
  return Number.isNaN(numericStatus) ? status : numericStatus;
};
